module.exports = __webpack_public_path__ + "img/jaleixo.67a6373f.png";